<template>
  <button ref="button" type="button" class="btn" @click.prevent="onClicked" :disabled="disabled" :data-style="loadingStyle" :data-spinner-color="loadingColour"><slot /></button>
</template>

<style lang="scss">
@import "~ladda/css/ladda.scss";
</style>

<script>
import * as Ladda from 'ladda/js/ladda'
import formField from '@/mixins/formField'

export default {
  name: "FormButton",
  mixins: [formField],
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    loadingStyle: {
      type: String,
      default: 'expand-right'
    },
    loadingColour: {
      type: String,
      default: '#FFF'
    }
  },
  watch: {
    loading: function(newVal, oldVal) {
      if(newVal)
        this.ladda.start();
      else
        this.ladda.stop();
    }
  },
  mounted () {
    this.ladda = Ladda.create(this.$refs.button);
  },
  beforeDestroy() {
    this.ladda.remove()
  },
  methods: {
    onClicked(evt) {
      this.$emit('click', evt)
    },
    focus() {
      this.$refs.button.focus()
    }
  }
}
</script>